























































































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import GImportModal from '@/components/GImportModal.vue';
import GDuplicateNameDifferencesTable from '@/views/GStudents/GDuplicateNameDifferencesTable.vue';
import GStudentDifferencesTable from '@/views/GStudents/GStudentDifferencesTable.vue';
import GStudentImportErrorModal from '@/views/GStudents/GStudentImportErrorModal.vue';
import GStudentImportYearConfirmModal from '@/views/GStudents/GStudentImportYearConfirmModal.vue';
import GStudentImportUploadConfirm from '@/views/GStudents/GStudentImportUploadConfirm.vue';
import GStudentImportStudentListModal from '@/views/GStudents/GStudentImportStudentListModal.vue';
import GStudentImportPreCheck from '@/views/GStudents/GStudentImportPreCheck.vue';
import { GEnum } from '@/constants/enum.defination';
import { GPageBase } from '@/mixins';
import { studentModule } from '@/store/modules/entities/student.module';
import { importModalModule } from '@/store/modules/frames/import-modal.module';
import { PostStudentFileRequest } from '@/models/student/post-student-file-request';
import {
  CheckErrorData,
  CheckStudentDifferencesResult,
  ClassStudent,
  DuplicateNameDifference,
  GradeClassCount,
  StudentDifference,
} from '@/models/student/check-student-differences-result';
import { cookieService } from '@/service/cookie.service';

enum ImportConfirmStep {
  NONE = 0,
  PRE_CHECK = 1,
  UPLOAD_CONFIRM = 2,
  DIFF_REVIEW = 3,
}

@Component({
  name: 'GStudentImport',
  components: {
    GImportModal,
    GDuplicateNameDifferencesTable,
    GStudentDifferencesTable,
    GStudentImportErrorModal,
    GStudentImportYearConfirmModal,
    GStudentImportUploadConfirm,
    GStudentImportStudentListModal,
    GStudentImportPreCheck,
  },
})
export default class GStudentImport extends Mixins(GPageBase) {
  // 既存
  showStudentImportModal: boolean = false;
  canChangePassword: boolean = false;
  checkStudentDifferencesResult: CheckStudentDifferencesResult = null;
  @Prop() value: boolean;

  // 新規追加
  ImportConfirmStep = ImportConfirmStep;
  uploadedFormData: FormData = null;
  uploadedFileName: string = '';
  importStep: ImportConfirmStep = ImportConfirmStep.NONE;
  showErrorModal: boolean = false;
  showYearConfirmModal: boolean = false;
  showNoTargetModal: boolean = false;
  showStepModal: boolean = false;
  showStudentListModal: boolean = false;
  showBillingConfirmModal: boolean = false;
  selectedClass: { grade: number; className: string } = { grade: 0, className: '' };
  allGradesChecked: boolean = false;
  allPreChecked: boolean = false;
  isUploading: boolean = false;

  @Watch('value')
  openModal(value: boolean) {
    this.showStudentImportModal = value;
  }

  @Watch('showStudentImportModal')
  close(value: boolean) {
    this.$emit('input', value);
    if (!value) {
      this.resetFlow();
    }
  }

  // ── computed ──────────────────────────────────────────

  get registrationCount(): number {
    if (!this.checkStudentDifferencesResult) return 0;
    const v = this.checkStudentDifferencesResult.registrationCount;
    return v !== undefined ? v : 0;
  }

  get existingRegistrationCount(): number {
    const counts = this.gradeClassCounts;
    if (counts.length > 0) {
      return counts.reduce((s, c) => s + c.existingCount, 0);
    }
    const r = this.checkStudentDifferencesResult;
    const nameOrMail = r ? r.studentDifferencesNameOrMailAddress : null;
    const others = r ? r.studentDifferencesOthers : null;
    return (nameOrMail ? nameOrMail.length : 0) + (others ? others.length : 0);
  }

  // 新規登録件数。既存・合計と同じ優先順位で、gradeClassCountsがあればそちらを集計元にする
  get newRegistrationCount(): number {
    const counts = this.gradeClassCounts;
    if (counts.length > 0) {
      return counts.reduce((s, c) => s + c.newCount, 0);
    }
    return this.registrationCount;
  }

  get totalRegistrationCount(): number {
    const counts = this.gradeClassCounts;
    if (counts.length > 0) {
      return counts.reduce((s, c) => s + c.totalCount, 0);
    }
    return this.newRegistrationCount + this.existingRegistrationCount;
  }

  get checkErrors(): CheckErrorData[] {
    const r = this.checkStudentDifferencesResult;
    return r && r.checkErrors ? r.checkErrors : [];
  }

  get duplicateNameDifferences(): DuplicateNameDifference[] {
    const r = this.checkStudentDifferencesResult;
    return r && r.duplicateNameDifferences ? r.duplicateNameDifferences : [];
  }

  get studentDifferencesNameOrMailAddress(): StudentDifference[] {
    const r = this.checkStudentDifferencesResult;
    return r && r.studentDifferencesNameOrMailAddress ? r.studentDifferencesNameOrMailAddress : [];
  }

  get studentDifferencesOthers(): StudentDifference[] {
    const r = this.checkStudentDifferencesResult;
    return r && r.studentDifferencesOthers ? r.studentDifferencesOthers : [];
  }

  get gradeClassCounts(): GradeClassCount[] {
    const r = this.checkStudentDifferencesResult;
    return r && r.gradeClassCounts ? r.gradeClassCounts : [];
  }

  get hasDiffData(): boolean {
    return (
      this.duplicateNameDifferences.length > 0 ||
      this.studentDifferencesNameOrMailAddress.length > 0 ||
      this.studentDifferencesOthers.length > 0
    );
  }

  get isRoleIgsAdmin(): boolean {
    return this.$store.state.account.isRoleIgsAdmin;
  }

  get registrationYear(): number {
    return cookieService.schoolYearInt;
  }

  get stepModalTitle(): string {
    switch (this.importStep) {
      case ImportConfirmStep.UPLOAD_CONFIRM: return '登録内容の確認';
      case ImportConfirmStep.PRE_CHECK:      return '登録前の確認';
      case ImportConfirmStep.DIFF_REVIEW:   return '修正内容の確認';
      default: return '';
    }
  }

  get stepModalWidth(): number {
    return this.importStep === ImportConfirmStep.UPLOAD_CONFIRM ? 760 : 1200;
  }

  // 新規のみの登録（差分データなし）のときは、上下の余白を詰める。
  // 閉じるアニメーション中はresetFlow()でhasDiffDataが変化するため、表示中のみ判定する
  get isCompactStep(): boolean {
    return this.showStepModal && this.importStep === ImportConfirmStep.DIFF_REVIEW && !this.hasDiffData;
  }

  // 登録するデータが全て既存データ（新規登録が0件）の場合は、登録前の確認画面をスキップする。
  // ただし学年・クラス別集計が取得できていない場合（API未対応）は、UPLOAD_CONFIRMも無条件通過になり
  // 確認事項に一度も同意しないまま登録まで進めてしまうため、スキップしない
  get shouldSkipPreCheck(): boolean {
    return this.gradeClassCounts.length > 0 && this.newRegistrationCount === 0;
  }

  get canProceed(): boolean {
    switch (this.importStep) {
      case ImportConfirmStep.UPLOAD_CONFIRM:
        // gradeClassCountsがない場合（バックエンド未対応）はそのまま進める
        return this.gradeClassCounts.length === 0 || this.allGradesChecked;
      case ImportConfirmStep.PRE_CHECK:
        return this.allPreChecked;
      case ImportConfirmStep.DIFF_REVIEW:
        // checkErrorsは①のエラーモーダルで既にブロック済みだが、防御的にここでも次へを止める
        return this.checkErrors.length === 0;
      default:
        return false;
    }
  }

  get selectedClassStudents(): ClassStudent[] {
    const r = this.checkStudentDifferencesResult;
    if (!r || !r.studentsByClass) return [];
    const { grade, className } = this.selectedClass;
    if (!className) {
      const prefix = `${grade}-`;
      return Object.entries(r.studentsByClass)
        .filter(([key]) => key.startsWith(prefix))
        .flatMap(([, students]) => students);
    }
    const list = r.studentsByClass[`${grade}-${className}`];
    return list ? list : [];
  }

  // ── handlers ─────────────────────────────────────────

  handleStudentTemplateDownload() {
    studentModule.downloadRegistrationTemplate().then(() => {
      importModalModule.setIsDownloading(false);
    });
  }

  async handleStudentUpload(formData: FormData, fileName: string = '') {
    this.uploadedFormData = formData;
    this.uploadedFileName = fileName;
    const postStudentFileRequest = { formData, canChangePassword: this.canChangePassword } as PostStudentFileRequest;
    studentModule
      .checkStudentDifferences(postStudentFileRequest)
      .then((response: any) => {
        if (response) {
          this.checkStudentDifferencesResult = response.data;
          if (this.checkErrors.length > 0) {
            this.showErrorModal = true;
          } else if (
            this.newRegistrationCount === 0 &&
            !this.hasDiffData &&
            !(this.canChangePassword && this.isRoleIgsAdmin)
          ) {
            this.showNoTargetModal = true;
          } else {
            this.showYearConfirmModal = true;
          }
        }
      })
      .finally(() => {
        importModalModule.setIsCheckDifferenceRunning(false);
      });
  }

  handleNoTargetOK() {
    this.showNoTargetModal = false;
    this.checkStudentDifferencesResult = null;
  }

  handleErrorModalOK() {
    // エラーがあるので前の画面（アップロード）に戻るだけ
    this.checkStudentDifferencesResult = null;
  }

  handleYearConfirmBack() {
    this.checkStudentDifferencesResult = null;
  }

  handleYearConfirmOK() {
    this.allPreChecked = false;
    this.allGradesChecked = false;
    this.importStep = this.shouldSkipPreCheck ? ImportConfirmStep.UPLOAD_CONFIRM : ImportConfirmStep.PRE_CHECK;
    this.showStepModal = true;
  }

  handleStepModalClose() {
    this.showStepModal = false;
    this.resetFlow();
  }

  // showStepModalをfalseにすればv-ifで子コンポーネントは破棄されるため、importStepは据え置きでよい
  // （NONEにするとモーダルの閉じるアニメーション中にタイトルが消え、幅も変わってちらつく）
  backToYearConfirm() {
    this.showStepModal = false;
    this.showYearConfirmModal = true;
  }

  handleStepBack() {
    switch (this.importStep) {
      case ImportConfirmStep.PRE_CHECK:
        this.backToYearConfirm();
        break;
      case ImportConfirmStep.UPLOAD_CONFIRM:
        this.allPreChecked = false;
        // 登録前の確認画面をスキップしている場合は、登録年度の確認まで戻す
        if (this.shouldSkipPreCheck) {
          this.backToYearConfirm();
        } else {
          this.importStep = ImportConfirmStep.PRE_CHECK;
        }
        break;
      case ImportConfirmStep.DIFF_REVIEW:
        this.importStep = ImportConfirmStep.UPLOAD_CONFIRM;
        this.allGradesChecked = false;
        break;
    }
  }

  handleStepNext() {
    switch (this.importStep) {
      case ImportConfirmStep.PRE_CHECK:
        this.allGradesChecked = false;
        this.importStep = ImportConfirmStep.UPLOAD_CONFIRM;
        break;
      case ImportConfirmStep.UPLOAD_CONFIRM:
        this.importStep = ImportConfirmStep.DIFF_REVIEW;
        break;
      case ImportConfirmStep.DIFF_REVIEW:
        this.showBillingConfirmModal = true;
        break;
    }
  }

  onUploadConfirmCheckedChange(allChecked: boolean) {
    this.allGradesChecked = allChecked;
  }

  onPreCheckCheckedChange(allChecked: boolean) {
    this.allPreChecked = allChecked;
  }

  onShowStudentList({ grade, schoolClassName }: { grade: number; schoolClassName: string | null }) {
    this.selectedClass = { grade, className: schoolClassName !== null && schoolClassName !== undefined ? schoolClassName : '' };
    this.showStudentListModal = true;
  }

  handleBillingBack() {
    this.showBillingConfirmModal = false;
  }

  async handleRegister() {
    if (!this.uploadedFormData) return;
    this.isUploading = true;
    importModalModule.setIsUploading(true);
    const postStudentFileRequest = { formData: this.uploadedFormData, canChangePassword: this.canChangePassword } as PostStudentFileRequest;
    studentModule
      .postStudentFile(postStudentFileRequest)
      .then((response: any) => {
        this.showBillingConfirmModal = false;
        this.showStepModal = false;
        if (response) {
          let messages: string[] = [];
          if (response.data.registrationCount > 0) {
            messages.push(`${this.$t('REGISTRATION_COUNT').toString()}：${response.data.registrationCount}${this.$t('UNIT.COUNT').toString()}`);
          }
          if (response.data.updatedCount > 0) {
            messages.push(`${this.$t('UPDATE_COUNT').toString()}：${response.data.updatedCount}${this.$t('UNIT.COUNT').toString()}`);
          }
          this.showNotice(GEnum.MessageType.Success, this.$t('NOTICE.TITLE.UPDATE_COMPLETED').toString(), messages.join('<br/>'), 10);
          this.lazyAction(() => { window.location.reload(); }, 5000);
        }
      })
      .finally(() => {
        this.isUploading = false;
        importModalModule.setIsUploading(false);
      });
  }

  resetFlow() {
    this.checkStudentDifferencesResult = null;
    this.uploadedFormData = null;
    this.uploadedFileName = '';
    // importStepはhandleYearConfirmOKで必ず設定し直されるためリセットしない
    // （NONEにするとモーダルの閉じるアニメーション中にタイトルが消え、幅も変わってちらつく）
    this.showErrorModal = false;
    this.allGradesChecked = false;
    this.allPreChecked = false;
    this.showStudentListModal = false;
  }
}
